
//公用接口
const com = {
  getYearList:"/mobile/v1/year/zktYear/list",//年度表-分页列表查询(get)
  getHomeList:"/mobile/v1/yunying/zktYunying/list",//年度表-分页列表查询(get)
  getPageConfig:"/mobile/v1/page/zktPage/queryById",//自定义页面表-通过id查询,
  getPolicyList:"/mobile/v1/townPolicyPublish/zktTownPolicyPublish/list",//镇街政策表-列表查询(get)
  getZktTownlist:"/mobile/v1/town/zktTown/list2",//获取镇街列表的数据(get)
  getZktTownQaList:"/mobile/v1/townQa/zktTownQa/list",
  getZktTownQaListPublish:"/mobile/v1/townQaPublish/zktTownQaPublish/list",
  getSchoolList:"/mobile/v1/schoolPublish/zktSchoolPublish/list",//获取学校列表,
  getSchoolDetails:"/mobile/v1/release/zktRelease/queryByYearUserIdOpenType",//学校详情(get)
  zktTownHomePublish:"/mobile/v1/townHomePublish/zktTownHomePublish/list",
  getAuditProgress:"/internal/auditProgress/list",
}

//义务教育阶段
const comEduStage = {
  zktTownHomeById:"/mobile/v1/townHome/zktTownHome/queryByTownIdAndYear",//镇街主页表-通过id查询(get)
}

//中考阶段接口
const midEduStage = {
  queryDxzsList:"/mobile/v1/schoolVideoPublish/zktSchoolVideoPublish/list",//莞校志 
}

//字典
const dict = {
  queryCanConfigTownList:"/yearUserPerm/zktYearUserPerm/queryCanConfigTownList",//可配置镇街(get)
  queryCanCheckTownList:"/yearUserPerm/zktYearUserPerm/queryCanCheckTownList",//镇街审核范围(get)
  getCanCheckSchoolList:"/yearUserPerm/zktYearUserPerm/getCanCheckSchoolList",//返回教育部门可预审的学校列表(get)
  getCanCheckOfficeList:"/yearUserPerm/zktYearUserPerm/getCanCheckOfficeList",//返回可预审的教育部门列表
}

export default {
  com,
  comEduStage,
  midEduStage,
  dict
}
